export default "__VITE_ASSET__CvnNYZXK__"